import { useLayoutEffect, useRef, useState } from "react";

const DEFAULT_WIDTH = 320;

export default function MeasuredChartFrame({
    height = 320,
    minWidth = 260,
    children,
}) {
    const frameRef = useRef(null);
    const [size, setSize] = useState({
        width: DEFAULT_WIDTH,
        height,
    });

    useLayoutEffect(() => {
        const element = frameRef.current;
        if (!element) return undefined;

        let frameId = null;

        const updateSize = () => {
            if (frameId) {
                window.cancelAnimationFrame(frameId);
            }

            frameId = window.requestAnimationFrame(() => {
                const rect = element.getBoundingClientRect();

                const measuredWidth =
                    rect.width || element.clientWidth || element.offsetWidth || DEFAULT_WIDTH;

                const nextWidth = Math.max(Math.floor(measuredWidth), minWidth);

                setSize({
                    width: nextWidth,
                    height,
                });
            });
        };

        updateSize();

        let resizeObserver = null;

        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(updateSize);
            resizeObserver.observe(element);
        }

        window.addEventListener("resize", updateSize);

        return () => {
            if (frameId) {
                window.cancelAnimationFrame(frameId);
            }

            if (resizeObserver) {
                resizeObserver.disconnect();
            }

            window.removeEventListener("resize", updateSize);
        };
    }, [height, minWidth]);

    return (
        <div
            ref={frameRef}
            style={{
                width: "100%",
                maxWidth: "100%",
                height,
                minHeight: height,
                minWidth: 0,
                position: "relative",
                overflow: "hidden",
            }}
        >
            {typeof children === "function" ? children(size) : null}
        </div>
    );
}